module.exports = __webpack_public_path__ + "img/Feature.7d28b974.jpg";